// extracted by mini-css-extract-plugin
export default {"allocations_table_wrapper":"Table_allocations_table_wrapper__eFolD","table_header":"Table_table_header__M3-U5"};